import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import ServiceLayout from '../components/ServiceLayout';

export default function DigitalMarketing() {
  return (
    <Layout>
      <ServiceLayout
        title="Digital Marketing"
        banner="/assets/images/banner/digi.jpg"
        current="/digital-marketing"
      >
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-brand-dark mb-4">Digital Marketing</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              Welcome to our digital marketing hub, where we specialize in driving growth and maximizing visibility for businesses in the digital realm.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              With a focus on Search Engine Optimization (SEO), App Store Optimization (ASO), Social Media Marketing (SMM), and Search Engine Marketing (SEM), we offer a comprehensive suite of services to elevate your online presence.
            </p>
            <h3 className="text-lg font-bold font-heading text-brand-dark mb-3">Building Brand Presence and Loyalty</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              In the realm of social media, we craft strategic plans, curate compelling content, and manage communities across various platforms including Facebook, Instagram, Twitter, LinkedIn, and more. By fostering meaningful interactions and building brand loyalty, we help you establish a robust social media presence.
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 list-none p-0">
              {['Precision Advertising', 'Global Reach'].map((item) => (
                <li key={item} className="flex items-center gap-3 text-brand-dark/80 text-sm">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand/10 flex items-center justify-center">
                    <span className="icon-check-circle text-brand text-xs"></span>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <img src="digitalmark.jpg" alt="#" className="w-full rounded-2xl shadow-md" />

          <div>
            <p className="text-gray-600 leading-relaxed mb-6">
              Digital marketing is an ongoing process, and we are committed to continuously optimizing and refining our strategies to adapt to changing trends, algorithms, and consumer behaviour.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { icon: 'icon-web-design', title: 'Strategic Planning', desc: 'We collaborate to grasp your business goals, audience, and competition, crafting bespoke digital strategies aligned with your specific objectives.' },
                { icon: 'icon-data', title: 'Data-Driven Insights', desc: 'We use analytics to track digital marketing, identify improvements, and drive data-informed decisions for maximizing ROI.' },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="flex items-start gap-4 bg-gray-50 rounded-xl p-5 border border-gray-100">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-brand flex items-center justify-center">
                    <span className={`${icon} text-white text-xl`}></span>
                  </div>
                  <div>
                    <h3 className="text-brand-dark font-bold font-heading mb-2">{title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="flex-1">
              <p className="text-gray-600 leading-relaxed">
                Every company in the field of digital marketing has a special tale to tell. Our goal is to transform yours into a fascinating success tale — creating strategies that speak to your target market, strengthen your brand, and provide impressive growth and conversion rates.
              </p>
            </div>
            <div className="flex-shrink-0 md:w-48">
              <img src="/assets/images/services/img2.png" alt="#" className="w-full rounded-xl shadow-sm" />
            </div>
          </div>
        </div>
      </ServiceLayout>
    </Layout>
  );
}
